import React, { useEffect, useState } from 'react'
import classes from './EmailTeamsForm.module.scss'
import i18next from '../../translations'
import api from '../../api'
import Surface from '../Surface/Surface'
import SurfaceBody from '../SurfaceBody/SurfaceBody'
import PopupButtons from '../PopupButtons/PopupButtons'
import Button from '../Button/Button'
import SelectList from '../SelectList/SelectList'
import neutralizeEvent from '../../utils/neutralizeEvent'
import addMessage from '../../utils/addMessage'
import { formatDistanceToNow } from 'date-fns'
import getLocale from '../../utils/getLocale'

const EmailTeamsForm = (props) => {
  const {
    activityId,
    onCancel,
    callback
  } = props

  const [teamOptions, setTeamOptions] = useState([])
  const [selectedTeamIds, setSelectedTeamIds] = useState([])

  useEffect(() => {
    const locale = getLocale()
    api.club.getClubs()
      .then((clubs) => {
        api.activity.getActivity(activityId)
          .then((activity) => {
            const teamOptions = activity.attendingTeams
              .filter(({ attendees, team }) => !attendees.length && team.active)
              .map(({ team, lastReminded: lastRemindedTimeStamp }) => {
                const lastReminded = lastRemindedTimeStamp
                  ? formatDistanceToNow(new Date(lastRemindedTimeStamp), { addSuffix: true, locale })
                  : '-'
                const club = clubs.find((club) => club._id === team.club)
                return {
                  id: team._id,
                  value: {
                    [i18next.t('common:club')]: club.name,
                    [i18next.t('common:team')]: team.name + (team.active ? '' : ` (${i18next.t('common:inactive')})`),
                    [i18next.t('common:last_reminder')]: lastReminded
                  }
                }
              })
            setTeamOptions(teamOptions)
          })
      })
  }, [activityId])

  const updateValue = ({ target }) => {
    setSelectedTeamIds(target.value)
  }

  const handleSubmit = (event) => {
    neutralizeEvent(event)
    api.activity.sendReminders(activityId, selectedTeamIds)
      .then((result) => {
        const remindedTeams = (result && result.remindedTeams) || []
        const skippedTeams = (result && result.skippedTeams) || []
        const failedRecipients = (result && result.failedRecipients) || []

        // success feedback for the teams that were actually reminded
        if (remindedTeams.length === 1) {
          addMessage(i18next.t('common:mails_sent_to_x', { x: remindedTeams[0] }), { type: 'success' })
        } else if (remindedTeams.length > 1) {
          addMessage(i18next.t('common:mails_sent_to_amount_teams', { amount: remindedTeams.length }), { type: 'success' })
        }

        // warn about teams that could not be reminded
        if (skippedTeams.length) {
          addMessage(i18next.t('common:mails_skipped_no_coach', { teams: skippedTeams.join(', ') }), { type: 'warning' })
        }
        if (failedRecipients.length) {
          addMessage(i18next.t('common:mails_failed_for', { recipients: failedRecipients.join(', ') }), { type: 'warning' })
        }

        callback()
      })
      .catch((error) => {
        console.error('sendReminders failed', error)
        addMessage(i18next.t('common:something_went_wrong'), { type: 'error' })
      })
  }

  return (
    <form onSubmit={handleSubmit}>
      <Surface>
        <SurfaceBody>
          <div className={classes.selectListContainer}>
            <SelectList
              value={selectedTeamIds}
              options={teamOptions}
              onChange={updateValue}
            />
          </div>
        </SurfaceBody>
        <PopupButtons>
          <div className={classes.invitedTeamsCount}>
            {selectedTeamIds.length}/{teamOptions.length} {i18next.t('common:teams_selected')}
          </div>
          <Button onClick={onCancel}>{i18next.t('actions:cancel')}</Button>
          <Button type='submit' theme='primary' disabled={!selectedTeamIds.length}>{i18next.t('actions:send_emails')}</Button>
        </PopupButtons>
      </Surface>
    </form>
  )
}

export default EmailTeamsForm
